export default {
  primaryButton: {
    background: 'linear-gradient(180deg, #4B9BFF 0%, #2B7FDB 100%)',
    color: '#FFFFFF',
    fontWeight: 600,
    '&:hover': {
      opacity: 0.9,
    },
  },
  secondaryButton: {
    background: 'linear-gradient(180deg, #6B7280 0%, #4B5563 100%)',
    color: '#FFFFFF',
    fontWeight: 600,
    '&:hover': {
      opacity: 0.9,
    },
  },
};